import React from 'react';
import * as commonConstants from '../../../constants/constants';
const invoiceConstants = require('../../../constants/invoicecreation/constants');
const PAGE_MESSAGE_CONSTANTS = invoiceConstants.RESULT_PAGE_MESSAGE;

class InvoiceResultPageMessage extends React.Component {

    render() {

        let pageMessage;
        if (Number(this.props.recordsType) === commonConstants.SUCCESS_RECORDS_TYPE) {
            pageMessage = PAGE_MESSAGE_CONSTANTS.INVOICE_SUCCESS_INFO;
        } else if (Number(this.props.recordsType) === commonConstants.FAILURE_RECORDS_TYPE) {
            pageMessage = PAGE_MESSAGE_CONSTANTS.INVOICE_FAILURE_INFO;

        } else if (Number(this.props.recordsType) === commonConstants.INPROCESS_RECORDS_TYPE) {
            pageMessage = PAGE_MESSAGE_CONSTANTS.INVOICE_INPROCESS_INFO;
        } else {
            pageMessage = '';
        }

        return (
            <React.Fragment>
                <div className="message-info">
                    {pageMessage}
                </div>
            </React.Fragment>
        );
    }

}

export default InvoiceResultPageMessage;